import { defineMessages } from 'react-intl';

export const scope = 'app.component.base.accordion';

export default defineMessages({
  toggle_accordion_button: {
    id: `${scope}.toggle_accordion_button`,
    defaultMessage: 'Toggle accordion button',
  },
});
